import { useEffect, type RefObject } from 'react';

// Links, buttons that are not disabled, input fields that are not disabled or hidden, select elements that are not disabled, and text areas that are not disabled
const interactiveSelectors =
	'a[href]:not([tabindex="-1"]), button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled])';

export const useFocusFirstInteractiveElement = (containerRef: RefObject<HTMLElement> | null) => {
	useEffect(() => {
		if (!containerRef?.current) {
			return;
		}

		const firstFocusableElement =
			containerRef.current.querySelector<HTMLElement>(interactiveSelectors);

		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (firstFocusableElement && !__SERVER__ && document.activeElement !== firstFocusableElement) {
			firstFocusableElement.focus();
		}
	}, [containerRef]);
};
